<template>
  <md-dialog :md-active.sync="showApplicationsDialog">
    <div class="s1-loc__progress-spinner-wrapper" v-show="saving">
      <md-progress-spinner class="md-accent" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <md-dialog-title>
      <div class="s1-U__align-children--center s1-U__justify-content--space-between">
        <div>
          <p class="md-caption s1-U__text-uppercase">{{ name }}</p>
          <p>{{ $t('modal.applications.title') }}</p>
        </div>
        <md-button class="md-icon-button s1-U__mg--lt32" @click="close">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </md-dialog-title>
    <md-divider/>
    <md-content class="md-scrollbar s1-U__pd0-force" style="overflow: auto">
      <div class="s1-U__pd--bt16 s1-U__pd--tp16">
        <div v-for="application in applications" v-bind:key="application.applicationId">
          <div
            class="s1-U__pd--lt20 s1-U__pd--rt20 s1-U__pd--bt8 s1-U__pd--tp8"
            v-if="application.Key1 !== 'customerServiceAPI'"
          >
            <div class="s1-U__align-children--center s1-U__justify-content--space-between">
              <div class="s1-U__align-children--center">
                <img class="s1-U__mg--rt16" style="width: 48px;" :src="application.applicationIcon" alt>
                <span class="s1-U__pd--rt16 s1-U__text-ellipsis">{{application.applicationName}}</span>
              </div>
              <md-switch
                class="md-primary"
                :class="(application.default) && 's1-U__opacity--40'"
                v-model="application.currentValue"
                :disabled="application.default"
              ></md-switch>
            </div>
          </div>
        </div>
        <h4 v-if="notAllowedApplications && notAllowedApplications.length" class="s1-U__mg--tp32 s1-U__mg--bt8 s1-U__pd--lt20 s1-U__pd--rt20 s1-U__text-color--dark-2">Aplicações não disponíveis</h4>
        <div v-for="application in notAllowedApplications" v-bind:key="`${application.applicationId}-2`">
          <div class="s1-U__pd--lt20 s1-U__pd--rt20 s1-U__pd--bt8 s1-U__align-children--center s1-U__justify-content--space-between">
            <div class="s1-U__align-children--center">
              <img
                class="s1-U__mg--rt16"
                style="width: 48px;filter: grayscale(1);"
                :src="application.IconUri"
                alt
              >
              <span class="s1-U__pd--rt16 s1-U__text-ellipsis">{{application.Name}}</span>
            </div>
          </div>
        </div>
      </div>
    </md-content>
    <md-divider/>

    <md-dialog-actions class="s1-U__pd20">
      <md-button class="md-primary md-raised" @click="showApplicationsDialog = false">{{ $t('modal.applications.save') }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  data: () => ({
    showApplicationsDialog: false,
    saving: false,
  }),
  computed: {
    ...mapState('applicationsModal', {
      name: 'name',
    }),
    ...mapGetters('applicationsModal', {
      applications: 'ALLOWED_APPS',
      notAllowedApplications: 'NOT_ALLOWED_APPS',
    }),
  },
  methods: {
    ...mapActions('applicationsModal', {
      initStore: 'INIT',
      persist: 'PERSIST',
    }),
    open(type, id, companyId, name) {
      this.initStore({
        type,
        id,
        companyId,
        name,
      }).then(() => {
        this.showApplicationsDialog = true;
      });
    },
    close() {
      this.$emit('close');
      this.showApplicationsDialog = false;
    },
    save() {
      this.saving = true;
      this.persist().then(() => {
        this.saving = false;
        this.$emit('saved');
        this.close();
      });
    }
  }
};
</script>
